import React from "react";
import { Routes, Route } from "react-router-dom";
import Agriculture from "../views/Agriculture";
import Banking from "../views/Banking";
import Healthcare from "../views/Healthcare";
import Home from "../views/Home";
import Insurance from "../views/Insurance";
import Manufacturing from "../views/Manufacturing";
import Media from "../views/Media";
import Professional from "../views/Professional";
import RealEstate from "../views/RealEstate";
import Retail from "../views/Retail";
import Software from "../views/Software";
import Telecommunications from "../views/Telecommunications";
import Transportation from "../views/Transportation";
import Utilities from "../views/Utilities";
import Warehousing from "../views/Warehousing";
import Wholesale from "../views/Wholesale";
import Companies from "../views/Companies";
import CompanyNavigationMenu from "../views/Companies/CompanyNavigationMenu";
import Financials from "../views/Companies/Financials";
import CompanyEvents from "../views/Companies/CompanyEvents";
import CompanyFilings from "../views/Companies/CompanyFilings";
import CompanyNews from "../views/Companies/CompanyNews";
import ComparativeAnalytics from "../views/Companies/ComparativeAnalytics";
import CompanyDescription from "../views/Companies/Description";
import CompanyDirectors from "../views/Companies/Directors";
import EarningsAndEstimates from "../views/Companies/Earnings&Estimates";
import FinancialTrend from "../views/Companies/FinancialTrend";
import Management from "../views/Companies/Management";
import CompanyOverview from "../views/Companies/Overview";
import CompanyResearch from "../views/Companies/Research";
import Suburbs from "../views/RealEstate/LandPrices/Suburbs";
import Satellite from "../views/RealEstate/LandPrices/Satellite";
import Hospitality from "../views/RealEstate/Hospitality";
import Construction from "../views/RealEstate/Construction";
import TreasuryBills from "../views/Banking/TreasuryBills";
import TreasuryBonds from "../views/Banking/TreasuryBonds";
import ForexRates from "../views/Banking/ForexRates";
import InterestRates from "../views/Banking/InterestRates";
import InterBankRates from "../views/Banking/InterBankRates";
import LandTransactions from "../views/RealEstate/LandTransactions";
import MergersAcquisitions from "../views/MergersAcquisitions";
import Macros from "../views/Macros";
import RealGDP from "../views/Macros/RealGDP";
import Population from "../views/Macros/Population";
import Employment from "../views/Macros/Employment";
import Unemployment from "../views/Macros/Unemployment";
import PublicExpenditure from "../views/Macros/PublicExpenditure";
import GovernmentRevenues from "../views/Macros/GovementRevenues";
import NationalBudget from "../views/Macros/NationalBudget";
import NationalDebt from "../views/Macros/NationalDebt";
import BalanceOfPayments from "../views/Macros/BalanceOfPayments";
import ExchangeRates from "../views/Macros/ExchangeRates";
import RealGDPGrowthRates from "../views/Macros/RealGDPGrowthRates";
import RealGDPPerCapita from "../views/Macros/RealGDPPerCapita";
import NominalGDP from "../views/Macros/NominalGDP";
import NominalGDPGrowthRates from "../views/Macros/NominalGDPGrowthRates";
import NominalGDPPerCapita from "../views/Macros/NominalGDPPerCapita";
import RealGDPPerCapitaChange from "../views/Macros/RealGDPPerCapitaChange";
import Industries from "../views/Industries";
import IndustryReports from "../views/IndustryReports";
import IndustryReport from "../views/IndustryReports/IndustryReport";
import ContactDB from "../views/ContactDB";
import PrivateCompanies from "../views/PrivateCompanies";
import TalentDB from "../views/TalentDB";
import AdminCenter from "../views/AdminCenter";
import Login from "../views/Login";
import Register from "../views/Register";
import Layout from "../components/Layout";
import ProtectedRoute from "./ProtectedRoute";
import AuthenticatedRedirectRoute from "./AuthenticatedRedirectRoute";
import AdminCenterLayout from "../components/AdminCenter/AdminCenterLayout";
import AdminCenterUserManagement from "../views/AdminCenter/AdminCenterUserManagement";
import AdminCenterRequestsManagement from "../views/AdminCenter/AdminCenterRequestsManagement";
import AdminCenterBillingManagement from "../views/AdminCenter/AdminCenterBillingManagement";
import AdminCenterAdminSettings from "../views/AdminCenter/AdminCenterAdminSettings";
import InvestorsDB from "../views/InvestorsDB";
import LendersDB from "../views/LendersDB";
import ExpertsDB from "../views/ExpertsDB";
import PublicRelationsDB from "../views/PublicRelationsDB";
import { useSelector } from "react-redux";
import IndustryReportLayout from "../components/IndustryReport/IndustryReportLayout";
import Overview from "../views/IndustryReports/Chapters/Overview";
import ExecutiveSummary from "../views/IndustryReports/Chapters/ExecutiveSummary";
import CompetitiveLandscape from "../views/IndustryReports/Chapters/CompetitiveLandscape";
import OperatingConditions from "../views/IndustryReports/Chapters/OperatingConditions";
import KeyStatistics from "../views/IndustryReports/Chapters/KeyStatistics";
import IndustryOutlook from "../views/IndustryReports/Chapters/IndustryOutlook";
import KeyTrends from "../views/IndustryReports/Chapters/KeyTrends";
import KeySuccessFactors from "../views/IndustryReports/Chapters/KeySuccessFactors";
import MajorCompanies from "../views/IndustryReports/Chapters/MajorCompanies";
import SWOTAnalysis from "../views/IndustryReports/Chapters/SWOTAnalysis";
import PESTLEAnalysis from "../views/IndustryReports/Chapters/PESTLEAnalysis";
import SupplyChain from "../views/IndustryReports/Chapters/SupplyChain";

export default function AllRoutes() {
  const user = useSelector((state) => state.user.user)
  return (
    <>
      <Routes>
        <Route element={<ProtectedRoute isAllowed={!!user} />}>
          <Route path="/" element={
            <Layout>
              <Home />
            </Layout>
          } />
          <Route path="industries" element={
            <Layout>
              <Industries />
            </Layout>
          } />
          <Route path="industries/real-estate" element={
            <Layout>
              <RealEstate />
            </Layout>
          } />
          <Route path="industries/real-estate/construction" element={
            <Layout>
              <Construction />
            </Layout>
          } />
          <Route path="industries/real-estate/land-prices-suburbs" element={
            <Layout>
              <Suburbs />
            </Layout>
          } />
          <Route
            path="industries/real-estate/land-prices-satellites"
            element={
              <Layout>
                <Satellite />
              </Layout>
            }
          />
          <Route
            path="industries/real-estate/hospitality-intelligence"
            element={
              <Layout>
                <Hospitality />
              </Layout>
            }
          />
          <Route
            path="industries/real-estate/land-transactions"
            element={
              <Layout>
                <LandTransactions />
              </Layout>
            }
          />

          <Route path="industries/agriculture" element={
            <Layout>
              <Agriculture />
            </Layout>
          } />
          <Route path="industries/banking" element={
            <Layout>
              <Banking />
            </Layout>
          } />
          <Route path="industries/banking/treasury-bills" element={
            <Layout>
              <TreasuryBills />
            </Layout>
          } />
          <Route path="industries/banking/treasury-bonds" element={
            <Layout>
              <TreasuryBonds />
            </Layout>
          } />
          <Route path="industries/banking/forex-rates" element={
            <Layout>
              <ForexRates />
            </Layout>
          } />
          <Route path="industries/banking/interest-rates" element={
            <Layout>
              <InterestRates />
            </Layout>
          } />
          <Route path="industries/banking/interbank-rates" element={
            <Layout>
              <InterBankRates />
            </Layout>
          } />
          <Route path="industries/insurance" element={
            <Layout>
              <Insurance />
            </Layout>
          } />
          <Route path="industries/health" element={
            <Layout>
              <Healthcare />
            </Layout>
          } />
          <Route path="industries/media" element={
            <Layout>
              <Media />
            </Layout>
          } />
          <Route path="industries/telecoms" element={
            <Layout>
              <Telecommunications />
            </Layout>
          } />
          <Route path="industries/software" element={
            <Layout>
              <Software />
            </Layout>
          } />
          <Route path="industries/transportation" element={
            <Layout>
              <Transportation />
            </Layout>
          } />
          <Route path="industries/warehousing" element={
            <Layout>
              <Warehousing />
            </Layout>
          } />
          <Route path="industries/retail" element={
            <Layout>
              <Retail />
            </Layout>
          } />
          <Route path="industries/utilities" element={
            <Layout>
              <Utilities />
            </Layout>
          } />
          <Route path="industries/manufacturing" element={
            <Layout>
              <Manufacturing />
            </Layout>
          } />
          <Route path="industries/wholesale" element={
            <Layout>
              <Wholesale />
            </Layout>
          } />
          <Route path="industries/professional" element={
            <Layout>
              <Professional />
            </Layout>
          } />

          <Route path="companies" element={
            <Layout>
              <Companies />
            </Layout>
          } />
          <Route
            path="companies/:companyId"
            element={
              <Layout>
                <CompanyNavigationMenu />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/financials"
            element={
              <Layout>
                <Financials />
              </Layout>
            }
          />
          <Route path="companies/:companyId/events" element={
            <Layout>
              <CompanyEvents />
            </Layout>
          } />
          <Route
            path="companies/:companyId/filings"
            element={
              <Layout>
                <CompanyFilings />
              </Layout>
            }
          />
          <Route path="companies/:companyId/news" element={
            <Layout>
              <CompanyNews />
            </Layout>
          } />
          <Route
            path="companies/:companyId/comparative-analytics"
            element={
              <Layout>
                <ComparativeAnalytics />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/description"
            element={
              <Layout>
                <CompanyDescription />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/directors"
            element={
              <Layout>
                <CompanyDirectors />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/earnings-and-estimates"
            element={
              <Layout>
                <EarningsAndEstimates />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/financial-trend"
            element={
              <Layout>
                <FinancialTrend />
              </Layout>
            }
          />
          <Route path="companies/:companyId/management" element={
            <Layout>
              <Management />
            </Layout>
          } />
          <Route
            path="companies/:companyId/overview"
            element={
              <Layout>
                <CompanyOverview />
              </Layout>
            }
          />
          <Route
            path="companies/:companyId/research"
            element={
              <Layout>
                <CompanyResearch />
              </Layout>
            }
          />

          <Route path="mergers-acquisitions" element={
            <Layout>
              <MergersAcquisitions />
            </Layout>
          } />

          <Route path="macros" element={
            <Layout>
              <Macros />
            </Layout>
          } />
          <Route path="macros/gdp" element={
            <Layout>
              <RealGDP />
            </Layout>
          } />
          <Route path="macros/gdp-growth-rates" element={
            <Layout>
              <RealGDPGrowthRates />
            </Layout>
          } />
          <Route path="macros/gdp-per-capita" element={
            <Layout>
              <RealGDPPerCapita />
            </Layout>
          } />
          <Route path="macros/gdp-per-capita-change" element={
            <Layout>
              <RealGDPPerCapitaChange />
            </Layout>
          } />
          <Route path="macros/nominal-gdp" element={
            <Layout>
              <NominalGDP />
            </Layout>
          } />
          <Route path="macros/nominal-gdp-growth-rates" element={
            <Layout>
              <NominalGDPGrowthRates />
            </Layout>
          } />
          <Route path="macros/nominal-gdp-per-capita" element={
            <Layout>
              <NominalGDPPerCapita />
            </Layout>
          } />
          <Route path="macros/population" element={
            <Layout>
              <Population />
            </Layout>
          } />
          <Route path="macros/employment" element={
            <Layout>
              <Employment />
            </Layout>
          } />
          <Route path="macros/unemployment" element={
            <Layout>
              <Unemployment />
            </Layout>
          } />
          <Route path="macros/public-expenditure" element={
            <Layout>
              <PublicExpenditure />
            </Layout>
          } />
          <Route path="macros/government-revenues" element={
            <Layout>
              <GovernmentRevenues />
            </Layout>
          } />
          <Route path="macros/national-budget" element={
            <Layout>
              <NationalBudget />
            </Layout>
          } />
          <Route path="macros/national-debt" element={
            <Layout>
              <NationalDebt />
            </Layout>
          } />
          <Route path="macros/balance-of-payments" element={
            <Layout>
              <BalanceOfPayments />
            </Layout>
          } />
          <Route path="macros/exchange-rates" element={
            <Layout>
              <ExchangeRates />
            </Layout>
          } />

          <Route path="reports" element={
            <Layout>
              <IndustryReports />
            </Layout>
          } />
          {/* <Route path="reports/:reportId" element={
            // <Layout>
            //   <IndustryReport />
            // </Layout>
            <IndustryReportLayout>
              <IndustryReport />
            </IndustryReportLayout>
          } /> */}
          <Route path="reports/:reportId/overview" element={
            <IndustryReportLayout>
              <Overview />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/executive-summary" element={
            <IndustryReportLayout>
              <ExecutiveSummary />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/competitive-landscape" element={
            <IndustryReportLayout>
              <CompetitiveLandscape />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/operating-conditions" element={
            <IndustryReportLayout>
              <OperatingConditions />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/key-stats" element={
            <IndustryReportLayout>
              <KeyStatistics />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/industry-outlook" element={
            <IndustryReportLayout>
              <IndustryOutlook />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/key-trends" element={
            <IndustryReportLayout>
              <KeyTrends />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/key-success-factors" element={
            <IndustryReportLayout>
              <KeySuccessFactors />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/major-companies" element={
            <IndustryReportLayout>
              <MajorCompanies />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/swot-analysis" element={
            <IndustryReportLayout>
              <SWOTAnalysis />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/pestle-analysis" element={
            <IndustryReportLayout>
              <PESTLEAnalysis />
            </IndustryReportLayout>
          } />
          <Route path="reports/:reportId/supply-chain" element={
            <IndustryReportLayout>
              <SupplyChain />
            </IndustryReportLayout>
          } />
          <Route path="contacts" element={
            <Layout>
              <ContactDB />
            </Layout>
          } />
          <Route path="private-companies" element={
            <Layout>
              <PrivateCompanies />
            </Layout>
          } />
          <Route path="talent" element={
            <Layout>
              <TalentDB />
            </Layout>
          } />
          <Route path="investors" element={
            <Layout>
              <InvestorsDB />
            </Layout>
          } />
          <Route path="lenders" element={
            <Layout>
              <LendersDB />
            </Layout>
          } />
          <Route path="expertsdb" element={
            <Layout>
              <ExpertsDB />
            </Layout>
          } />
          <Route path="prdb" element={
            <Layout>
              <PublicRelationsDB />
            </Layout>
          } />
        </Route>
        {/* <Route
          path="analytics"
          element={
            <ProtectedRoute
              redirectPath="/home"
              isAllowed={
                !!user && user.permissions.includes('analyze')
              }
            >
              <Analytics />
            </ProtectedRoute>
          }
        /> */}
        <Route element={
          <ProtectedRoute
            redirectPath="/"
            isAllowed={!!user && user.roles.includes('admin')}
          />}>
          {/* <Route element={
            <AdminCenterLayout />
          } >
            <Route path="admin-center" element={<AdminCenter />}>
              <Route index path="admin-center" element={<AdminCenter />} />
              <Route path="user-management" element={<AdminCenterUserManagement />} />
              <Route path="requests-management" element={<AdminCenterRequestsManagement />} />
              <Route path="billing" element={<AdminCenterBillingManagement />} />
              <Route path="admin-settings" element={<AdminCenterAdminSettings />} />
            </Route>
          </Route> */}
          <Route path="admin-center/overview" element={
            <AdminCenterLayout>
              <AdminCenter />
            </AdminCenterLayout>
          } />
          <Route path="admin-center/user-management" element={
            <AdminCenterLayout>
              <AdminCenterUserManagement />
            </AdminCenterLayout>
          } />
          <Route path="admin-center/requests-management" element={
            <AdminCenterLayout>
              <AdminCenterRequestsManagement />
            </AdminCenterLayout>
          } />
          <Route path="admin-center/billing" element={
            <AdminCenterLayout>
              <AdminCenterBillingManagement />
            </AdminCenterLayout>
          } />
          <Route path="admin-center/admin-settings" element={
            <AdminCenterLayout>
              <AdminCenterAdminSettings />
            </AdminCenterLayout>
          } />
        </Route>

        {/* <Route
          path="admin-center"
          element={
            <ProtectedRoute
              redirectPath="/"
              isAllowed={!!user && user.roles.includes('admin')}
            >
              <AdminCenterLayout>
                <AdminCenter />
              </AdminCenterLayout>
            </ProtectedRoute>
          }
        /> */}

        <Route element={<AuthenticatedRedirectRoute hasUser={user} />}>
          <Route path="login" element={
            <Login />
          }
          />
          <Route path="register" element={
            <Register />
          }
          />
        </Route>

        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </>
  );
}
